import { Form, FormInstance, FormItemProps } from 'antd';
import { createContext, useContext, useEffect, useState } from 'react';
import { DataViewProps } from './DataView';
import { merge } from '../../utils/PropsUtils';

export const DataFormContext = createContext<FormInstance<any>>({} as FormInstance<any>);
export const DataFormContextData = createContext<any>({} as any);

export const useDataForm = Form.useForm

export const DataForm = function <T>(
    props: DataViewProps<T> & { 
        children: any,
        onValuesChange?: (data: T) => void
    }
) {

    //const [form] = Form.useForm(); // Movido a DataFormContext
    const form = useContext(DataFormContext);

    const { data, setData } = props;
    const [ formData, setFormData ] = useState<T | undefined>();

    useEffect(() => {
        if (data===formData) return;

        setFormData(data);
        form.resetFields();
        form.setFieldsValue(data);
    }, [ data ]);

    const onValuesChange = (changedValues: any, allValues: any) => { 
        const _formData = merge(formData, changedValues);
        if (props.onValuesChange) props.onValuesChange(_formData);

        form.setFieldsValue(_formData);
        setFormData(_formData);
        setData(_formData);
    }

    // set errors dynamically
    // form.setFields([
    //     {
    //       name: 'field-to-update',
    //       errors: ['error-string'],
    //     },
    // ]);

    return (
        <DataFormContextData.Provider value={data}>
        <Form form={form}
            
            labelCol={{ span: 3 }}
            autoComplete="off"
            onValuesChange={onValuesChange}
        >
            {props.children}
        </Form>
        </DataFormContextData.Provider>
    );

};

export const useInnerDataByFormName = (name:string | string[]) => {
    const data = useContext(DataFormContextData)
    if (!data) return undefined;
    name = Array.isArray(name) ? name : [ name ];
    let innerData = data;
    for (let i = 0; i < name.length; i++) {
        innerData = innerData[name[i]];
        if (!innerData) return undefined;
    }
    return innerData;
}
